/**
 * Where the API lives.
 *
 * Mirrors the member app's rule (NFR-10.3.1): a release build must be HTTPS, and
 * a non-https URL is refused before any request is made rather than sending an
 * admin's credentials in the clear.
 */

const REQUEST_TIMEOUT_MS = 20000;

function resolveBaseUrl(): string {
  const configured = import.meta.env.VITE_API_URL?.trim();

  if (configured) {
    if (import.meta.env.PROD && !configured.startsWith("https://")) {
      // NFR-10.3.1. A production admin panel talking plain HTTP would put a
      // bearer token on the wire in every request.
      // The message names the variable and the fix, not the requirement - it is
      // shown to whoever deployed this, and the comment above carries the FR.
      throw new Error("VITE_API_URL must be an https:// URL in a production build.");
    }
    return configured.replace(/\/$/, "");
  }

  if (import.meta.env.DEV) {
    // The dev default documented in api/README.md. Kept out of the production
    // path entirely so a misconfigured deploy fails loudly instead of quietly
    // pointing at a developer's laptop.
    return "http://localhost:8000";
  }

  throw new Error("VITE_API_URL is not set. See admin-web/.env.example.");
}

export const API_BASE_URL = resolveBaseUrl();
export { REQUEST_TIMEOUT_MS };
